'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _slicedToArray = require('@babel/runtime/helpers/slicedToArray');
var reactSvg = require('react-svg');
var react = require('@linaria/react');
var PropTypes = require('prop-types');
var React = require('react');
var Loader = require('./Loader.js');
var jsxRuntime = require('react/jsx-runtime');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _slicedToArray__default = /*#__PURE__*/_interopDefaultLegacy(_slicedToArray);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

var version = "2.0.0-alpha.51";
var info = {
	version: version
};

var propTypes = {
  /** The name of the icon you'd like displayed. See storybook for a full list of icons. */
  iconName: PropTypes__default["default"].string.isRequired,
  /** Style properties for the div containing the svg */
  styles: PropTypes__default["default"].object.isRequired,
  /** Additional className for the div containing the svg */
  className: PropTypes__default["default"].string,
  /** The start of a URL where the icons are hosted. Should contain protocol and host. i.e. https://my.assets.com. */
  iconHost: PropTypes__default["default"].string,
  /** Aria label to be read by screen readers. When present, role changes from 'presentational' to 'img'. */
  ariaLabel: PropTypes__default["default"].string,
  /** Prop for react-svg component. Can be set to false when testing. https://www.npmjs.com/package/react-svg */
  requestCache: PropTypes__default["default"].bool,
  /** A query param that will trigger a cache refresh */
  cacheBustingQuery: PropTypes__default["default"].string,
  /** Overrides default highlight color */
  highlightColor: PropTypes__default["default"].string
};
var _exp = function _exp() {
  return function (_ref) {
    var highlightColor = _ref.highlightColor;
    return highlightColor || 'var(--color-secondary-action-lightest)';
  };
};
var StyledSvgContainer = /*#__PURE__*/react.styled('div')({
  name: "StyledSvgContainer",
  "class": "so74002",
  propsAsIs: false,
  vars: {
    "so74002-0": [_exp()]
  }
});
/**
 * Render a dual icon. These icons differ from font icons by having a color
 * highlight which should change with the theme of the site. They should also be
 * used like an image, rather than a character in a text block.
 *
 * @param props - component props
 * @param props.iconName - the name of the icon you'd like displayed. See storybook for a full list of icons.
 * @param props.styles - style properties for the div containing the svg
 * @param props.className - additional className for the div containing the svg
 * @param props.iconHost - The start of a URL where the icons are hosted. Should contain protocol and host. i.e. https://my.assets.com.
 * @param props.ariaLabel - Aria label to be read by screen readers. When present, role changes from 'presentational' to 'img'.
 * @param props.requestCache - Prop for react-svg component. Can be set to false when testing. https://www.npmjs.com/package/react-svg
 * @param props.cacheBustingQuery - A query param that will trigger a cache refresh
 * @param props.highlightColor - Overrides default highlight color
 * @returns A react element which inlines the svg of the given icon.
 */
var DualIcon = function DualIcon(_ref2) {
  var iconName = _ref2.iconName,
    styles = _ref2.styles,
    className = _ref2.className,
    iconHost = _ref2.iconHost,
    ariaLabel = _ref2.ariaLabel,
    _ref2$requestCache = _ref2.requestCache,
    requestCache = _ref2$requestCache === void 0 ? true : _ref2$requestCache,
    _ref2$cacheBustingQue = _ref2.cacheBustingQuery,
    cacheBustingQuery = _ref2$cacheBustingQue === void 0 ? "".concat(info.version) : _ref2$cacheBustingQue,
    highlightColor = _ref2.highlightColor;
  var _useState = React.useState(),
    _useState2 = _slicedToArray__default["default"](_useState, 2),
    error = _useState2[0],
    setError = _useState2[1];
  if (error) {
    console.warn('Dual icon failed to render: ', error);
    return null;
  }
  var hostUrl = iconHost || 'https://static-dev.rate.com';
  return /*#__PURE__*/jsxRuntime.jsx(StyledSvgContainer, {
    "data-testid": "svg-container",
    className: "rc-dual-icon__".concat(iconName, " ").concat(className || ''),
    style: styles,
    highlightColor: highlightColor,
    children: /*#__PURE__*/jsxRuntime.jsx(reactSvg.ReactSVG, {
      beforeInjection: function beforeInjection(svg) {
        // set height and width to fill the container
        svg.setAttribute('width', '100%');
        svg.setAttribute('height', 'auto');
        // Since our use of the dual icons is presentational we want to remove them from the accessibility tree used by screen readers.
        // Read more: https://www.w3.org/WAI/ARIA/apg/practices/hiding-semantics/#:~:text=Three%20common%20uses%20of%20role,do%20not%20convey%20meaningful%20relationships.
        svg.setAttribute('role', ariaLabel ? 'img' : 'presentation');
        if (ariaLabel) svg.setAttribute('aria-label', ariaLabel);
      },
      afterInjection: function afterInjection(error, svg) {
        if (error) {
          setError(new Error("Failed to load dual icon '".concat(iconName, "': "), error));
        }
      },
      src: "".concat(hostUrl, "/dual-icons/").concat(iconName, ".svg?q=").concat(cacheBustingQuery),
      loading: function loading() {
        return /*#__PURE__*/jsxRuntime.jsx(Loader["default"], {});
      },
      useRequestCache: !!requestCache
    })
  });
};
DualIcon.propTypes = propTypes;

exports["default"] = DualIcon;
